<template>
    <div class="frontend">
        <Header></Header>
        <router-view></router-view>
        <Footer></Footer>
    </div>
</template>

<script>
    import Header from "@/components/frontend/Header";
    import Footer from "@/components/frontend/Footer";
    export default {
        name: "FrontendLayout",
        components: {
            Footer,
            Header
        }
    }
</script>

<style lang="scss" scoped>
   @import "src/assets/scss/frontend.scss";
</style>

